/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Fulfillment_Waiting_On_DocumentInputs */

const en_fulfillment_waiting_on_document = /** @type {(inputs: Fulfillment_Waiting_On_DocumentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Business Central · invoice or proforma · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Business Central · invoice or proforma · since {since}" |
*
* @param {Fulfillment_Waiting_On_DocumentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_waiting_on_document = /** @type {((inputs: Fulfillment_Waiting_On_DocumentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Waiting_On_DocumentInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_waiting_on_document(inputs)
});